/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import getMeta from '@jira/platform__utils-get-meta/src/utils/get-meta/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';

export const isSynthetic = (): boolean =>
	// Filter out synthetic tests using all known ways
	getMeta('ajs-is-synthetic') === 'true' || fg('forge_ui_synthetic_check');
